import baseRoute from '../baseRoute';

export default `${baseRoute}/temporaryEmployee` as const;
